<toaster #toasterInstance></toaster>
<div class="policies-overview" *ngIf="customer">
  <div class="policies-overview-banner">
    <div class="policies-overview-banner__content">
      <div class="policies-overview-banner__title">Welcome, {{ customer.firstName }}</div>
      <div
        class="policies-overview-banner__subtitle"
        *ngIf="tabNameToApplications.Pending.length && tabNameToApplications.Pending.length === 1"
      >
        You have {{ tabNameToApplications.Pending.length }} pending application
      </div>
      <div
        class="policies-overview-banner__subtitle"
        *ngIf="tabNameToApplications.Pending.length && tabNameToApplications.Pending.length > 1"
      >
        You have {{ tabNameToApplications.Pending.length }} pending applications
      </div>
    </div>
  </div>

  <div class="policies-overview-tab-row">
    <button
      *ngIf="tabNameToApplications.Pending.length"
      (click)="selectedTab = 'Pending'"
      [ngClass]="{ 'policies-overview-tab': true, 'policies-overview-tab--active': selectedTab === 'Pending' }"
    >
      Pending ({{ tabNameToApplications.Pending.length }})
    </button>

    <button
      *ngIf="tabNameToApplications.Active.length"
      (click)="selectedTab = 'Active'"
      [ngClass]="{ 'policies-overview-tab': true, 'policies-overview-tab--active': selectedTab === 'Active' }"
    >
      Active ({{ tabNameToApplications.Active.length }})
    </button>

    <button
      *ngIf="tabNameToApplications.Canceled.length"
      (click)="selectedTab = 'Canceled'"
      [ngClass]="{ 'policies-overview-tab': true, 'policies-overview-tab--active': selectedTab === 'Canceled' }"
    >
      Canceled ({{ tabNameToApplications.Canceled.length }})
    </button>
  </div>

  <div class="policies-overview-cards">
    <ng-container *ngFor="let application of tabNameToApplications[selectedTab]">
      <policy-overview-card
        *ngIf="!application.primaryPolicy.isAnnuity()"
        [primaryPolicy]="application.primaryPolicyWithPendingAmendment"
      ></policy-overview-card>
      <annuity-overview-card
        *ngIf="application.primaryPolicy.isAnnuity()"
        [annuity]="asAnnuityApp(application).annuity"
      ></annuity-overview-card>
    </ng-container>
  </div>
</div>
